<template>
    <!-- CREATE NEW CUSTOMER WITH ORDER -->
    <validation-observer ref="observer" v-slot="{ passes, invalid }">
        <b-modal id="modal-create-new-order" size="lg" title="Create New Customer with Order" title-class="h4">
            <b-row>
                <b-col cols="6">
                    <validation-provider
                        name="Brand"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_first_name"
                            label="Brand"
                            label-for="input_brand"
                        >
                            <b-form-select v-model="create_new_order.brand.value"
                                           :options="create_new_order.brand.options"
                                           id="input_brand"
                                           :state="getValidationState(validationContext)"
                            >
                            </b-form-select>
                        </b-form-group>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <validation-provider
                        name="First Name"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_first_name"
                            label="First Name:"
                            label-for="input_first_name"
                        >
                            <b-form-input v-model="create_new_order.first_name"
                                          id="input_first_name"
                                          autocomplete="off"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-col>


                <b-col cols="6">
                    <validation-provider
                        name="Last Name"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_last_name"
                            label="Last Name:"
                            label-for="input_last_name"
                        >
                            <b-form-input v-model="create_new_order.last_name"
                                          id="input_last_name"
                                          autocomplete="off"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="8">
                    <validation-provider
                        name="Email"
                        :rules="{ required: true, email: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_email"
                            label="Email:"
                            label-for="input_email"
                        >
                            <b-form-input v-model="create_new_order.email"
                                          id="input_email"
                                          @blur="verifyEmail"
                                          autocomplete="off"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                            <span v-if="mailCheckedEmail" class='form--notice form--suggestEmail pointer'>Did you mean
                                <span class="font-weight-bold" @click="setEmail">{{ mailCheckedEmail }}</span>?
                            </span>
                        </b-form-group>
                    </validation-provider>
                </b-col>

                <b-col cols="4">
                    <validation-provider
                        name="Phone"
                        :rules="{ required: true, regex:/^\d{10}$/}"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_phone"
                            label="Phone:"
                            label-for="input_phone"
                        >
                            <b-form-input type="text" v-model="create_new_order.phone"
                                          id="input_phone"
                                          onkeyup="this.value=this.value.replace(/[^\d]/,'')"
                                          maxlength="10"
                                          autocomplete="off"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-col>
            </b-row>


            <b-row>
                <b-col cols="8">
                    <validation-provider
                        name="Address 1"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_address1"
                            label="Address 1:"
                            label-for="input_address1"
                        >
                            <b-form-input v-model="create_new_order.address.address1"
                                          id="input_address1"
                                          autocomplete="off"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-col>


                <b-col cols="4">
                    <b-form-group
                        id="input_group_address2"
                        label="Address 2:"
                        label-for="input_address2"
                    >
                        <b-form-input v-model="create_new_order.address.address2"
                                      id="input_address2"
                                      autocomplete="off"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <validation-provider
                        name="Zip"
                        :rules="{ required: true, min: 5 }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_zip"
                            label="Zip:"
                            label-for="input_zip"
                        >
                            <b-input-group>
                                <b-form-input v-model="create_new_order.address.zip"
                                              v-on:input="applyZip"
                                              id="input_zip"
                                              maxlength="5"
                                              autocomplete="off"
                                              :state="getValidationState(validationContext)"
                                ></b-form-input>
                                <template #append>
                                    <b-input-group-text class="bg-transparent border-0">
                                        <i class="fa-duotone fa-spinner fa-spin fa-fw text-dark" :class="{'invisible': !form.isLoadingZip}"></i>
                                    </b-input-group-text>
                                </template>
                            </b-input-group>
                        </b-form-group>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <validation-provider
                        name="City"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_city"
                            label="City:"
                            label-for="input_city"
                        >
                            <b-form-input v-model="create_new_order.address.city"
                                          id="input_city"
                                          autocomplete="off"
                                          :state="getValidationState(validationContext)"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-col>
                <b-col cols="4">
                    <validation-provider
                        name="State"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input_group_state"
                            label="State:"
                            label-for="input_state"
                        >
                            <input type="hidden" v-model="create_new_order.address.state">
                            <multiselect v-model="create_new_order.address.state"
                                         :options="US_STATES_LIST_FILTERED"
                                         :optionHeight="8" group-values="types" group-label="name"
                                         :searchable="true" :close-on-select="true" :show-labels="false"
                                         :group-select="false" track-by="id" label="name"
                                         :class="getValidationState(validationContext) ? 'border border-success' : 'border border-danger'"
                                         placeholder="Select State">

                            </multiselect>
                        </b-form-group>
                    </validation-provider>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="4">
                    <validation-provider
                        name="Shipping Method"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group
                            id="input-group-shipping"
                            label="Shipping Method:"
                            label-for="input-shipping-method"
                        >
                            <b-form-select v-model="create_new_order.shipping_method.value" :options="create_new_order.shipping_method.options"
                                           id="input-shipping-method"
                                           :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                    </validation-provider>
                </b-col>
                <b-col cols="4">
                    <validation-provider
                        name="Requested Number of Labels"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                    >
                        <b-form-group label="Requested Number of Labels:" label-class="font-weight-bold">
                            <b-input type="number" v-model.number="create_new_order.label_count">
                            </b-input>
                        </b-form-group>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    <b-form-group label="Home Pickup?" label-class="font-weight-bold"
                                  label-for="home_pickup">
                        <b-form-checkbox
                            v-bind:true-value="1"
                            v-bind:false-value="0"
                            data-editing="home_pickup"
                            switch
                            size="sm"
                            class="nice-toggle-success"
                            id="home_pickup"
                            v-model="create_new_order.home_pickup">
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="8">
                    <b-form-group label="Campaign:" label-class="font-weight-bold">
                        <b-form-radio-group>
                            <!--<b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="phone"><b>Phone</b>
                            </b-form-radio>-->
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="text"><b>Text</b>
                            </b-form-radio>
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="email"><b>Email</b>
                            </b-form-radio>
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="google"><b>Google</b>
                            </b-form-radio>
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="bing"><b>Bing</b>
                            </b-form-radio>
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="valpak"><b>Valpak</b>
                            </b-form-radio>
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="referral"><b>Referral</b>
                            </b-form-radio>
                            <!--
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="chat"><b>Chat</b>
                            </b-form-radio>
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="tv"><b>TV</b>
                            </b-form-radio>
                            <b-form-radio v-model="create_new_order.campaign.option_selected" name="campaign_options" value="other"><b>Other</b>
                            </b-form-radio>
                            <template v-if="create_new_order.campaign.option_selected == 'other' " class="mt-2">
                                <b-form-select id="campaign" v-model="create_new_order.campaign.value" name="campaign" class="mt-2" :options="create_new_order.campaign.options">
                                </b-form-select>
                            </template>
                            -->
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
                <b-button
                    variant="secondary"
                    class="float-right mr-2"
                    @click="$bvModal.hide('modal-create-new-order')"
                >Cancel
                </b-button>
                <b-button
                    @click="createNewOrder"
                    :disabled="invalid || form.isSaving"
                    variant="primary"
                    class="float-right"><i v-if="form.isSaving" class="fa-solid fa-spin fa-spinner mr-2"></i><i v-else class="fa-solid fa-magic mr-2"></i>Create New Order
                </b-button>
            </template>
        </b-modal><!-- end modal -->
    </validation-observer>
</template>

<script>
import _ from 'lodash';
import Multiselect from 'vue-multiselect';

    export default {
        name: 'CreateNewCustomerModal',
        props: {
        },
        components: {
            Multiselect,
        },
        data() {
            return {
                mailCheckedEmail: undefined,
                form: {
                    name: null,
                    order_id: null,
                    isBusy: false,
                    isOpen: false,
                    isSaving: false,
                    isLoadingZip: false,
                    items: [],

                    fields: [
                        {key: 'id', label: 'Customer #', class: 'text-center'},
                        {key: 'order_id', label: 'Order #', class: 'text-center'},
                        {key: 'full_name', label: 'Name', class: 'text-center'},
                        //{key: 'address', label: 'Address', class: 'text-center'},
                        //'actions',
                    ],
                },
                create_new_order: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    address: {
                        address1:'',
                        address2:'',
                        zip: '',
                        city: '',
                        state: null,
                    },
                    label_count: 1,
                    shipping_method: {
                        value: 'standard',
                        options: [
                            {value: 'standard', text: 'Standard Shipping'},
                            {value: 'two_day', text: '2-Day Shipping'},
                            {value: 'overnight', text: 'Overnight Shipping'}
                        ]
                    },
                    brand: {
                        value: null,
                        options: [],
                    },
                    campaign: {
                        value: 'phone',
                        options: [],
                        option_selected: 'phone',
                    },
                    home_pickup: false,
                },
            };
        },
        created() {
            this.$store.dispatch('LOAD_BRAND', (brands) =>
                _.each(brands, item => {
                    this.create_new_order.brand.options.push({value: item.id, text: item.name});
                })
            );
            this.$store.dispatch('GET_REQUEST', '/campaigns').then((campaigns) => {
                // console.log(campaigns);
                _.each(campaigns.data, item => {
                    // console.log(item);
                    this.create_new_order.campaign.options.push({value: item.id, text: item.name});
                });
            });
        },
        mounted() {
            if (this.$route.query.bid) {
                this.create_new_order.brand.value = this.$route.query.bid;
            }
            this.setUpMailCheck();
        },
        computed: {

        },
        methods: {
            setUpMailCheck: function () {
                const plugin = document.createElement('script');
                plugin.setAttribute(
                        'src',
                        'https://cdnjs.cloudflare.com/ajax/libs/mailcheck/1.1.2/mailcheck.js'
                );
                plugin.async = true;
                document.head.appendChild(plugin);
            },
            verifyEmail: function () {
                let self = this;
                Mailcheck.run({
                    email: self.create_new_order.email,
                    suggested: function (suggestion) {
                        self.mailCheckedEmail = suggestion.full;
                    },
                    empty: function () {

                    }
                });
            },
            setEmail: function () {
                this.create_new_order.email = this.mailCheckedEmail;
                this.mailCheckedEmail = undefined;
            },

            applyZip: _.debounce(function(e) {
                if(e.length === 5) { //check that its at least some kind of zip
                    this.form.isLoadingZip = true;
                    this.$http.get('customers/zip/' + e).then((s) => {
                        this.form.isLoadingZip = false;
                        if (s.data.city && s.data.state) {
                            this.create_new_order.address.city = s.data.city;
                            let search = _.filter(this.US_STATES_LIST_FILTERED[0].types, (e) => {
                                return s.data.state == e.id;
                            });
                            if (search && search[0]) {
                                this.create_new_order.address.state = search[0];
                            } else {
                                this.create_new_order.address.state = null;
                            }
                        }
                    });
                }
            }, 500),
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? valid : null;
            },
            createNewOrder(){
                let payload = {
                    brand_id: this.create_new_order.brand.value,
                    first_name: this.create_new_order.first_name,
                    last_name: this.create_new_order.last_name,
                    email: this.create_new_order.email,
                    phone: this.create_new_order.phone,
                    address1: this.create_new_order.address.address1,
                    address2: this.create_new_order.address.address2,
                    state: this.create_new_order.address.state.id,
                    zip: this.create_new_order.address.zip,
                    city: this.create_new_order.address.city,
                    home_pickup: this.create_new_order.home_pickup,
                    //campaign: this.create_new_order.campaign, #fixme, need campaigns to do this.
                    label_count: this.create_new_order.label_count,
                    abstract_shipping_level: this.create_new_order.shipping_method.value,
                };
                switch(this.create_new_order.campaign.option_selected) {
                    case null:
                        break;
                    case 'tv': // tv 98
                        payload.campaign = 98;
                        break;
                    case 'phone'://phone 89
                        payload.campaign = 89;
                        break;
                    case 'email'://email 108
                        payload.campaign = 108;
                        break;
                    case 'text'://text 107
                        payload.campaign = 107;
                        break;
                    case 'chat'://chat 103
                        payload.campaign = 103;
                        break;
                    case 'google':
                        payload.campaign = 109;
                        break;
                    case 'bing':
                        payload.campaign = 110;
                        break;
                    case 'valpak':
                        payload.campaign = 111;
                        break;
                    case 'referral':
                        payload.campaign = 112;
                        break;
                    case 'other':
                        payload.campaign = this.create_new_order.campaign.value;
                        break;
                }
                this.form.isSaving = true;
                this.$http.post('/customersKits',payload).then((resp)=> {
                    console.log(resp);
                    let data = resp.data;
                    if (data.success) {
                        this.$router.push('/kit/view/' + data.order.id);
                    } else if (data.can_navigate){
                        this.$parent.$bvModal.msgBoxConfirm(data.message, {
                            title: 'Customer has an order not received',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'success',
                            okTitle: 'Kit View',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        })
                            .then((e)=>{
                                if(e) {
                                    this.$router.push('/kit/view/' + data.order.id);
                                }
                            });

                    } else {
                        this.$parent.$bvModal.msgBoxOk(data.message, {
                            title: 'Issue Creating Customer',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    }
                    this.form.isSaving = false;
                });
            },
        },
        watch: {
        }
    };
</script>


<style scoped>
.multiselect__option {
    padding: 8px !important;
    line-height: 10px !important;
    min-height: 20px !important;
    font-size: 0.8em;
}
.multiselect__tags, .multiselect__select{
    padding:0;
    margin-left: 2px;
    min-height: 33px !important;
    height:33px !important;
    max-height: 33px !important;
}
.multiselect__placeholder{
    margin-left: 4px;
}
.multiselect__single {
    margin-top: 3px;
    font: 400 13px Arial;
}
.multiselect__tags {
    padding-top: 4px;
}
.multiselect {
    min-height: 33px !important;
    height:33px !important;
    max-height: 33px !important;
}

.multiselect__option--group.multiselect__option--disabled {
    font-weight: bold;
    color: black !important;
}
</style>
